import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, AlertTriangle, Lock, CreditCard, Mail, Shield } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
const CART_LINK = 'https://creaycrecepro.shop/checkouts/cn/hWNAWLippdzlLj2KbA0phaJ0/es-ar?_r=AQABXe45mcGQp256mwxnogXyZaN3X8TPMhy8oauCA9MChHo&preview_theme_id=193700921425';
export function PricingOffer() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="py-16 px-4 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div {...fadeInUp} className="text-center mb-8" data-id="element-115">
          <div className="inline-block bg-alert text-white px-6 py-3 rounded-full font-bold text-lg mb-6 animate-pulse" data-id="element-116">
            50% OFF
          </div>

          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-dark mb-6" data-id="element-117">
            HOY PODÉS LLEVARTE TODO POR SOLO
          </h2>

          <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8" data-id="element-118">
            <PriceDisplay amount={16500} showOriginal={true} originalAmount={33000} className="text-5xl md:text-7xl font-playfair font-bold text-primary" data-id="element-119" />
            <p className="text-dark/60 mt-2" data-id="element-120">
              Precio especial por tiempo limitado
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 mb-6" data-id="element-121">
            <p className="text-lg font-semibold text-dark mb-4" data-id="element-122">
              Y no solo eso… te lo llevás con:
            </p>
            <div className="space-y-3" data-id="element-123">
              {['50% OFF por tiempo limitado', 'acceso inmediato', 'bonos incluidos sin costo extra'].map((item, i) => <div key={i} className="flex items-center justify-center gap-3" data-id="element-124">
                  <CheckCircle className="w-6 h-6 text-primary flex-shrink-0" data-id="element-125" />
                  <span className="text-dark/80" data-id="element-126">{item}</span>
                </div>)}
            </div>
          </div>

          <motion.div className="bg-alert/10 border-2 border-alert/30 rounded-xl p-6 mb-8" animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-127">
            <div className="flex items-start gap-3 justify-center" data-id="element-128">
              <AlertTriangle className="w-6 h-6 text-alert flex-shrink-0 mt-1" data-id="element-129" />
              <p className="text-dark font-semibold text-left" data-id="element-130">
                Esta oferta promocional es por tiempo limitado y puede cerrarse
                en cualquier momento. Si estás viendo esta página ahora,
                aprovechá antes de que vuelva a su precio normal.
              </p>
            </div>
          </motion.div>

          <motion.a href={CART_LINK} className="inline-block w-full bg-accent hover:bg-accent/90 text-white font-bold text-xl px-8 py-6 rounded-xl shadow-2xl transition-all duration-300 mb-6" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-131">
            QUIERO MI RECETARIO ZERO AHORA
          </motion.a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-dark/70" data-id="element-132">
            <div className="flex items-center gap-2" data-id="element-133">
              <Lock className="w-5 h-5 text-primary" data-id="element-134" />
              <span data-id="element-135">Compra segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-136">
              <CreditCard className="w-5 h-5 text-primary" data-id="element-137" />
              <span data-id="element-138">Pago protegido</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-139">
              <Mail className="w-5 h-5 text-primary" data-id="element-140" />
              <span data-id="element-141">Acceso digital inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-142">
              <Shield className="w-5 h-5 text-primary" data-id="element-143" />
              <span data-id="element-144">Garantía de satisfacción de 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}